<template>
    <div>
        <h1>About Page</h1>
        <p>Esta es la página de información.</p>
    </div>
</template>

<script>
export default {
    name: 'About',
};
</script>
